import * as ProvisionActions from '../actions/provision-actions';
import { ProvisionData } from '../shared/models/provision.model';

export interface State {
  provisionData: ProvisionData;
}

export const initialState: State = {
  provisionData: undefined,
};

export function reducer(state = initialState, action: ProvisionActions.All): State {
  switch (action.type) {
    case ProvisionActions.PROVISION_GET:
      return Object.assign({}, state);
    case ProvisionActions.PROVISION_SAVE:
      return Object.assign({}, state, {
        provisionData: action.payload.provisionData,
      });
    case ProvisionActions.PROVISION_CLEAR:
      return Object.assign({}, state, {
        provisionData: undefined,
      });
    default:
      return state;
  }
}
